import { FETCH_START, FETCH_SUCCESS, FETCH_CODE_SENT } from '../../constants/ActionTypes';
import { dismissDialogLoading, showDialogLoading } from '@helpers/utils';
import CommonClass, { ICommon } from '../../models/redux/iCommon';
import { IDataReducer } from '../../models/generals/iDataReducer';
import GeneralsHelper from '@helpers/generalsHelper';

const INIT_STATE = new CommonClass('/', false, null, null);

export default (state = INIT_STATE, action: IDataReducer): ICommon => {
  switch (action.type) {
    case FETCH_START: {
      if (action.intl && action.idMessage && action.idMessage !== '') {
        let message: string = action.intl.formatMessage(
          {
            id: action.idMessage,
          },
          action.modelMessage,
        );
        showDialogLoading(action.intl, GeneralsHelper.capitalizeFirstLetter(message.toLowerCase()));
      }
      return { ...state, error: '', message: action.idMessage ?? null, loading: true };
    }
    case FETCH_SUCCESS: {
      if (state.message && state.message !== '') {
        dismissDialogLoading(state.message);
      }
      return { ...state, error: '', message: null, loading: false };
    }
    case FETCH_CODE_SENT: {
      return { ...state, error: '', message: null, loading: false };
    }
    default:
      return state;
  }
};
